import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'
import { initialPolygonState } from '../slices/polygon'
import { initialThreeDOnlyState } from '../slices/threeDOnly'
import { initialThreeDPrintOnlyState } from '../slices/threeDPrintOnly'

/**
 * Sets the asset type and resets the secondary chips specific to each asset
 * type, so toggles don't persist when switching type and back. Styles and tag
 * suggestions are asset-type-specific too, so they reset here (in the action,
 * not in component effects) - popstate restores assetType together with the
 * styles/tags the restored URL encodes, and an effect-based reset would wipe
 * them right back out.
 * @param {string} assetType - One of: "all", "3d_only", "3d_print_only"
 */
export const setAssetType = (assetType) => {
  if (searchPageStore.getState().assetType === assetType) return

  searchPageStore.setState({
    assetType,
    styles: DEFAULT_STATE.styles,
    tags: DEFAULT_STATE.tags,
    // Polygon filters are 3D-only UI (PolyCount only renders then), but buildSearchParams emits
    // polygon_range unconditionally - without this reset, leaving 3D Only would keep constraining
    // results through a filter no control shows anymore.
    ...initialPolygonState,
    ...initialThreeDOnlyState,
    ...initialThreeDPrintOnlyState,
  })
}
